import { env, redirectionErrorCodes } from "../constants/global.vars";
import { Member } from "../models/auth.model";
import paths from "../paths";
import { auth, authSubject, loginModalSubject } from "../store/auth.store";
import { ApiService } from "lib/http.service";
import { Storage } from "./localstorege.service";
import { exceptionModal, GetCookies } from "./misc.functions";
import { modalServiceSubject } from "./modal.service";
import { wssProvider } from "./websocket.service";
import { financialValidationService, financialValidationServiceSubject } from "../pages/login/financial.validation.pending";

interface RegisterPayload {
    first_name: string;
    last_name: string;
    tc_id: string;
    email: string;
    mobile: string;
    birthday?: string;
    birthday_day: string;
    birthday_month: string;
    birthday_year: string;
    profession: number;
    reference_id?: string;
    password: string;
    password_confirm: string;
    terms: boolean;
    privacy: boolean;
    commercial: boolean;
    validation_token?: string;
    cookie?: string;
}

interface LoginPayload {
    user: string;
    password: string;
    remember: boolean;
}

export enum LoginFromWhere {
    LOGIN_PAGE,
    REGISTER_FLOW,
    WS,
}

export class AuthService {
    searchParams: URLSearchParams;
    navigate: any;
    tempRegisterPayload: RegisterPayload | null = null;

    constructor(searchParams: any = null, navigate: any = null) {
        this.searchParams = searchParams
        this.navigate = navigate;
    }

    // Register Props
    async register(payload: RegisterPayload) {
        this.tempRegisterPayload = payload;

        auth.userValidation = false;
        const api = new ApiService();

        this.tempRegisterPayload.mobile = this.tempRegisterPayload.mobile.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "");
        this.tempRegisterPayload.birthday = this.tempRegisterPayload.birthday_year + "-" + this.tempRegisterPayload.birthday_month + "-" + this.tempRegisterPayload.birthday_day;

        let submitButton: any = document.getElementById("id_btnRegister");
        if (submitButton) {
            submitButton.disabled = true;
        }

        const cookieData = GetCookies();
        this.tempRegisterPayload.cookie = cookieData["initialTrafficSource"] || "";

        if (this.searchParams.get("utm_source")) {
            const cookieString = `utmcsr=${this.searchParams.get("utm_source")}|utmcmd=${this.searchParams.get("utm_medium")}|utmccn=${this.searchParams.get("utm_campaign")}`;
            this.tempRegisterPayload.cookie = cookieString;
        }

        try {
            const response: any = await api.start("post", env.accounting_api + "/member/api/register/", this.tempRegisterPayload, false);

            if (!response.status) {
                if (response.error === 'validation_token_required') {
                    this.getRegisterSMSValidationCode();
                    return;
                }
                if (response.error === "invalid_validation_token") {
                    this.tempRegisterPayload.validation_token = undefined;
                    this.getRegisterSMSValidationCode();
                    return;
                }
                modalServiceSubject.next({
                    case: "danger",
                    title: "Hata",
                    width: 380,
                    content: `<p>${response.message}</p>`,
                    confirm: {
                        cancel: {
                            label: "Tamam",
                            class: "btn-danger",
                        },
                        sure: redirectionErrorCodes.includes(response.error)
                            ? {
                                label: "Giriş yap",
                                action: () => {
                                    this.navigate(paths.login.url);
                                },
                            }
                            : null,
                    },
                });
                return;
            }

            await this.loginAfterRegister();
        } catch (e: any) {
            modalServiceSubject.next({
                case: "danger",
                title: "Hata",
                width: 380,
                content: `<p>Beklenmedik bir hata oluştu, lütfen daha sonra tekrar deneyiniz.</p>`,
                confirm: {
                    cancel: {
                        label: "Tamam",
                        class: "btn-danger",
                    },
                },
            });
        } finally {
            if (submitButton) {
                submitButton.disabled = false;
            }
        }
    };

    async getRegisterSMSValidationCode() {
        auth.userValidation = false;
        const api = new ApiService();

        try {
            const response: any = await api.start("post", env.accounting_api + "/member/api/mobile_validation/", this.tempRegisterPayload, false);
            if (!response.status) {
                modalServiceSubject.next({
                    case: "danger",
                    title: "Hata",
                    width: 380,
                    content: `<p>${response.message}</p>`,
                    confirm: {
                        cancel: {
                            label: "Tamam",
                            class: "btn-danger",
                        },
                        sure: redirectionErrorCodes.includes(response.error)
                            ? {
                                label: "Giriş yap",
                                action: () => {
                                    this.navigate(paths.login.url);
                                },
                            }
                            : null,
                    },
                });
                return;
            }

            if (response.data.timeout) {
                this.showRegisterValidationModal(response.data.timeout);
                return response;
            }
        } catch (e: any) {
            modalServiceSubject.next({
                case: "danger",
                title: "Hata",
                width: 380,
                content: `<p>Beklenmedik bir hata oluştu, lütfen daha sonra tekrar deneyiniz.</p>`,
                confirm: {
                    cancel: {
                        label: "Tamam",
                        class: "btn-danger",
                    },
                },
            });
        }
    };

    async loginAfterRegister() {
        if (!this.tempRegisterPayload) {
            return;
        }

        await this.login({
            user: this.tempRegisterPayload.tc_id,
            password: this.tempRegisterPayload.password,
            remember: true,
        }, LoginFromWhere.REGISTER_FLOW);
    };

    showRegisterValidationModal(timeout: number = 180) {
        if (!this.tempRegisterPayload) {
            return;
        }

        let mobile = this.tempRegisterPayload.mobile;
        let s: any = null;
        let sureButton: any = null;
        let resendButton: any = null;
        let validationErrorMessage: any = null;

        const senderTimer = () => {
            let resendTimer: any = document.getElementById("id_resendTimer");
            if (resendTimer) {
                let secondLeft: number = Number(
                    Number(resendTimer.innerHTML.split(":")[0]) * 60 + Number(resendTimer.innerHTML.split(":")[1]) - 1
                );
                if (secondLeft < 0) {
                    if (s) {
                        clearInterval(s);
                        s = null;
                    }
                    if (resendButton) {
                        resendButton.style.visibility = "visible";
                    }
                } else {
                    resendTimer.innerHTML = Math.floor(secondLeft / 60) + ":" + ("00" + (secondLeft % 60)).slice(-2);
                }
            }
        };

        const formatTime = (seconds: number) => {
            return Math.floor(seconds / 60) + ":" + ("00" + (seconds % 60)).slice(-2);
        };

        modalServiceSubject.next({
            title: "Cep Numaranızı Doğrulayın",
            confirm: {
                sure: {
                    label: "Doğrula",
                    async: true,
                    autoClose: false,
                    action: async () => {
                        if (!validationErrorMessage) {
                            validationErrorMessage = document.getElementById("id_validationErrorMessage");
                        }
                        if (validationErrorMessage) {
                            validationErrorMessage.style.display = "none";
                        }
                        const inputElements: any = document.querySelectorAll("input.code-input");
                        let validateCodeValue = [...inputElements].map((inp: any) => inp.value).join("");
                        if (validateCodeValue.length !== 6) {
                            if (validationErrorMessage) {
                                validationErrorMessage.innerHTML = "Lütfen doğrulama kodunu eksiksiz giriniz.";
                                validationErrorMessage.style.display = "block";
                            }
                        }

                        try {
                            const validationResponse = await this.validateMobile(this.tempRegisterPayload, validateCodeValue);


                            if (validationResponse === null || validationResponse === undefined) {
                                if (validationErrorMessage) {
                                    validationErrorMessage.innerHTML = 'Beklenmedik bir hata oluştu, lütfen daha sonra tekrar deneyiniz.';
                                    validationErrorMessage.style.display = "block";
                                }
                                return;
                            }

                            if (validationResponse.status === false) {
                                if (validationErrorMessage) {
                                    validationErrorMessage.innerHTML = validationResponse.message || "Doğrulama kodu geçersiz, lütfen kontrol ediniz.";
                                    validationErrorMessage.style.display = "block";
                                }
                                return;
                            }


                            if (this.tempRegisterPayload) {
                                this.tempRegisterPayload.validation_token = validationResponse.data.validation_token;
                                modalServiceSubject.next(null);
                                await this.register(this.tempRegisterPayload);
                            }
                        } catch (e: any) {
                            if (validationErrorMessage) {
                                validationErrorMessage.innerHTML = 'Beklenmedik bir hata oluştu, lütfen daha sonra tekrar deneyiniz.';
                                validationErrorMessage.style.display = "block";
                            }
                        }
                    },
                },
            },
            onClose: () => {
                if (s) {
                    clearInterval(s);
                    s = null;
                }
            },
            afterLoad: () => {
                if (s) {
                    clearInterval(s);
                }
                s = setInterval(senderTimer, 1000);
                validationErrorMessage = document.getElementById("id_validationErrorMessage");
                if (validationErrorMessage) {
                    validationErrorMessage.style.display = "none";
                }
                sureButton = document.getElementById("id_btnModelServiceSure");
                resendButton = document.getElementById("id_resendCode");
                if (sureButton) {
                    sureButton.disabled = true;
                }
                if (resendButton) {
                    resendButton.style.visibility = "hidden";
                    resendButton.addEventListener("click", async (e: any) => {
                        resendButton.style.visibility = "hidden";
                        let resendTimer: any = document.getElementById("id_resendTimer");
                        if (resendTimer) {
                            if (validationErrorMessage) {
                                validationErrorMessage.style.display = "none";
                            }

                            const response = await this.getRegisterSMSValidationCode();
                            if (response && response.data && response.data.timeout) {
                                resendTimer.innerHTML = formatTime(response.data.timeout);
                                if (s) {
                                    clearInterval(s);
                                }
                                s = setInterval(senderTimer, 1000);
                            }
                        }
                    });
                }

                const inputElements: any = document.querySelectorAll("input.code-input");
                inputElements.forEach((ele: any, index: any) => {
                    ele.addEventListener("keydown", (e: any) => {
                        // if the keycode is backspace & the current field is empty
                        // focus the input before the current. Then the event happens
                        // which will clear the "before" input box.
                        if (e.keyCode === 8 && e.target.value === "") inputElements[Math.max(0, index - 1)].focus();
                    });
                    ele.addEventListener("input", (e: any) => {
                        // take the first character of the input
                        // this actually breaks if you input an emoji like 👨‍👩‍👧‍👦....
                        // but I'm willing to overlook insane security code practices.
                        const [first, ...rest] = e.target.value;
                        e.target.value = first ?? ""; // first will be undefined when backspace was entered, so set the input to ""
                        const lastInputBox = index === inputElements.length - 1;
                        const didInsertContent = first !== undefined;
                        if (didInsertContent && !lastInputBox) {
                            // continue to input the rest of the string
                            inputElements[index + 1].focus();
                            // inputElements[index+1].value = rest.join('')
                            inputElements[index + 1].dispatchEvent(new Event("input"));
                        }

                        let validateCodeValue = [...inputElements].map((inp: any) => inp.value).join("");
                        if (validateCodeValue.length === 6) {
                            sureButton.disabled = false;
                        } else {
                            sureButton.disabled = true;
                        }
                    });
                });
            },
            content: `
              <p>
                ${mobile} GSM numaralı telefonunuza gönderdiğimiz doğrulama kodunu giriniz.
              </p>
              <div>
              
                <div id="id_validationErrorMessage" class="text-center alert alert-danger"></div>
                  
                <div class="mb-3 px-5 d-flex w-100">
                  <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
                  <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
                  <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
                  <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
                  <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
                  <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
                  <div class="clearfix"></div>
                </div>
                <div id="emailHelp" class="form-text"><span id="id_resendTimer">${formatTime(timeout)}</span> sonra tekrar gönder</div>
                <button style="bottom: 8px;" class="btn position-absolute btn-warning" id="id_resendCode">Tekrar Gönder</button>
              </div>`,
        });
    }


    // Login Props
    async login(payload: LoginPayload, fromWhere: LoginFromWhere) {
        let api = new ApiService();
        return await api
            .start("post", env.accounting_api + "/member/api/login/", payload, false)
            .then((res: any) => {
                if (res && res.status) {
                    auth.member = new Member(res.data.member);
                    auth.token = res.data.token;
                    auth.authentication = true;
                    Storage.set("token", res.data.token);
                    Storage.set("member", res.data.member);
                    Storage.del("financial_validation_message_data");
                    this.tempRegisterPayload = null;
                    financialValidationService.data = null;
                    financialValidationServiceSubject.next(false);
                    authSubject.next({ action: "login" });
                    wssProvider.user(auth.token);
                }
                else {
                    if (fromWhere === LoginFromWhere.LOGIN_PAGE) {
                        switch (res.error) {
                            case "sms_validate":
                                // this.getLoginSMSValidationCode(res.data);
                                // login bunu kendisi handle edecek
                                break;
                            case "financial_validation":
                                this.navigate(paths.home.url);
                                financialValidationService.data = payload;
                                financialValidationServiceSubject.next(true);
                                Storage.set("financial_validation_message_data", JSON.stringify(res.data));
                                wssProvider.setFinancialValidationListener(res.data.key);
                                break;
                            default:
                                return { status: false, error: res.error, message: res.message, data: null };
                        }
                    }
                    if (fromWhere === LoginFromWhere.WS) {
                        if (res.status) {
                            this.navigate(paths.home.url);
                        }
                        else {
                            switch (res.error) {
                                case "sms_validate":
                                    this.getLoginSMSValidationCode(res.data);
                                    break;
                                case "financial_validation":
                                    financialValidationServiceSubject.next(true);
                                    Storage.set("financial_validation_message_data", JSON.stringify(res.data.key));
                                    wssProvider.setFinancialValidationListener(res.data.key);
                                    break;
                                default:
                                    modalServiceSubject.next({
                                        title: "Hata",
                                        content: res.message || "Beklenmeyen bir hata oluştu, lütfen daha sonra tekrar deneyiniz.",
                                    });
                                    break;
                            }
                        }
                    };
                    if (fromWhere === LoginFromWhere.REGISTER_FLOW) {
                        switch (res.error) {
                            case "sms_validate":
                                this.getRegisterSMSValidationCode();
                                break;
                            case "financial_validation":
                                this.navigate(paths.home.url);
                                financialValidationService.data = this.tempRegisterPayload;
                                financialValidationServiceSubject.next(true);
                                Storage.set("financial_validation_message_data", JSON.stringify(res.data.key));
                                wssProvider.setFinancialValidationListener(res.data.key);
                                break;
                            default:
                                modalServiceSubject.next({
                                    case: "danger",
                                    title: "Giriş Hatası",
                                    content: res.message || "Beklenmedik bir hata oluştu, lütfen daha sonra tekrar deneyiniz.",
                                    confirm: {
                                        cancel: {
                                            label: "Tamam",
                                            class: "btn-danger",
                                        },
                                    },
                                });
                                break;
                        }
                    };
                }
                return res;
            })
            .catch((e: any) => {
                return { status: false, error: e, message: e, data: null };
            });
    };

    async getLoginSMSValidationCode(payload: any) {
        auth.userValidation = false;
        const api = new ApiService();

        try {
            const response: any = await api.start("post", env.accounting_api + "/member/api/mobile_validation/", payload, false);
            if (!response.status) {
                modalServiceSubject.next({
                    case: "danger",
                    title: "Hata",
                    width: 380,
                    content: `<p>${response.message}</p>`,
                    confirm: {
                        cancel: {
                            label: "Tamam",
                            class: "btn-danger",
                        },
                        sure: redirectionErrorCodes.includes(response.error)
                            ? {
                                label: "Giriş yap",
                                action: () => {
                                    this.navigate(paths.login.url);
                                },
                            }
                            : null,
                    },
                });
                return;
            }

            if (response.data.timeout) {
                return response;
            }
        } catch (e: any) {
            modalServiceSubject.next({
                case: "danger",
                title: "Hata",
                width: 380,
                content: `<p>Beklenmedik bir hata oluştu, lütfen daha sonra tekrar deneyiniz.</p>`,
                confirm: {
                    cancel: {
                        label: "Tamam",
                        class: "btn-danger",
                    },
                },
            });
        }
    };

    async sendValidationCode(payload: any) {
        let api = new ApiService();
        api
            .start("post", env.accounting_api + "/member/api/validation-member-sms/", payload, false)
            .then((res: any) => {
                console.info(res);
            })
            .catch((e: any) => {
                exceptionModal(e);
            });
    };

    async sendEmailValidationLink() {
        let api = new ApiService();
        api
            .start(
                "post",
                env.accounting_api + "/member/api/validation-email/",
                {
                    type: "register_send",
                    email: auth.member.email,
                    return_address: `${window.location.protocol}//${window.location.host}${paths.verifyEmail.url}`,
                },
                true
            )
            .then((res: any) => {

                if (res && res.status) {
                    modalServiceSubject.next({
                        title: res.message,
                        content: `<p>Lütfen eposta adresinize gönderilen doğrulama linkini tıklayarak doğrulama işleminizi tamamlayın. 
                    Eğer bir eposta almazsanız lütfen müşteri hizmetlerinden destek talep ediniz. </p>`,
                        confirm: {
                            cancel: {
                                label: "Tamam",
                            },
                        },
                    });
                } else {
                    modalServiceSubject.next({
                        case: 'danger',
                        title: 'Doğrulama Maili Gönderilemedi',
                        content: `<p>${res.message}<p/>`,
                        confirm: {
                            cancel: {
                                label: "Tamam",
                            },
                        },
                    });
                }
            });
    };

    async getGameRemains() {
        if (auth.member && auth.token) {
            let api = new ApiService();
            await api.start('', env.accounting_api + '/misc/api/list-game-reminder/', {}, true).then((res: any) => {

                if (res && res.status) {
                    auth.remaining_games = res.data.map((el: any, key: number) => {
                        return el.game_id;
                    });

                    authSubject.next({ action: 'checkAuth' })
                }

            }).catch((e: any) => {

            })
        }
    };

    async logUtm() {
        try {
            let api = new ApiService();
            var parameters = '';
            if (Storage.get('utm_source')) {
                parameters += '?utm_source=' + Storage.get('utm_source');
            }
            if (Storage.get('utm_medium')) {
                parameters += '&utm_medium=' + Storage.get('utm_medium');
            }
            if (Storage.get('utm_campaign')) {
                parameters += '&utm_campaign=' + Storage.get('utm_campaign');
            }
            if (Storage.get('utm_content')) {
                parameters += '&utm_content=' + Storage.get('utm_content');
            }
            if (auth.member) {
                parameters += '&user_id=' + auth.member.id;
            }
            await api
                .start("get", env.accounting_api + "/member/api/utm/" + parameters, {}, false).then((res: any) => {
                });
        } catch (e) {

        }
    };

    showLoginValidationModal(payload: any, timeout: number = 180) {
        let mobile = payload.mobile;
        let s: any = null;
        let sureButton: any = null;
        let resendButton: any = null;
        let validationErrorMessage: any = null;

        const senderTimer = () => {
            let resendTimer: any = document.getElementById("id_resendTimer");
            if (resendTimer) {
                let secondLeft: number = Number(
                    Number(resendTimer.innerHTML.split(":")[0]) * 60 + Number(resendTimer.innerHTML.split(":")[1]) - 1
                );
                if (secondLeft < 0) {
                    if (s) {
                        clearInterval(s);
                        s = null;
                    }
                    if (resendButton) {
                        resendButton.style.visibility = "visible";
                    }
                } else {
                    resendTimer.innerHTML = Math.floor(secondLeft / 60) + ":" + ("00" + (secondLeft % 60)).slice(-2);
                }
            }
        };

        const formatTime = (seconds: number) => {
            return Math.floor(seconds / 60) + ":" + ("00" + (seconds % 60)).slice(-2);
        };

        modalServiceSubject.next({
            title: "Cep Numaranızı Doğrulayın",
            confirm: {
                sure: {
                    label: "Doğrula",
                    autoClose: false,
                    async: true,
                    action: async () => {
                        if (!validationErrorMessage) {
                            validationErrorMessage = document.getElementById("id_validationErrorMessage");
                        }
                        if (validationErrorMessage) {
                            validationErrorMessage.style.display = "none";
                        }
                        const inputElements: any = document.querySelectorAll("input.code-input");
                        let validateCodeValue = [...inputElements].map((inp: any) => inp.value).join("");
                        if (validateCodeValue.length !== 6) {
                            if (validationErrorMessage) {
                                validationErrorMessage.innerHTML = "Lütfen doğrulama kodunu eksiksiz giriniz.";
                                validationErrorMessage.style.display = "block";
                            }
                        }

                        try {
                            const validationResponse = await this.validateMobile(payload, validateCodeValue);

                            if (!validationResponse || !validationResponse.status) {
                                if (validationErrorMessage) {
                                    validationErrorMessage.innerHTML = validationResponse.message || "Doğrulama kodu geçersiz, lütfen kontrol ediniz.";
                                    validationErrorMessage.style.display = "block";
                                }
                                return;
                            }

                            // payload.validation_token = validationResponse.data.validation_token;
                            // await this.register(payload);
                        } catch (e: any) {
                            if (validationErrorMessage) {
                                validationErrorMessage.innerHTML = "Doğrulama kodu geçersiz, lütfen kontrol ediniz.";
                                validationErrorMessage.style.display = "block";
                            }
                        }
                    },
                },
            },
            onClose: () => {
                if (s) {
                    clearInterval(s);
                    s = null;
                }
            },
            afterLoad: () => {
                if (s) {
                    clearInterval(s);
                }
                s = setInterval(senderTimer, 1000);
                validationErrorMessage = document.getElementById("id_validationErrorMessage");
                if (validationErrorMessage) {
                    validationErrorMessage.style.display = "none";
                }
                sureButton = document.getElementById("id_btnModelServiceSure");
                resendButton = document.getElementById("id_resendCode");
                if (sureButton) {
                    sureButton.disabled = true;
                }
                if (resendButton) {
                    resendButton.style.visibility = "hidden";
                    resendButton.addEventListener("click", async (e: any) => {
                        resendButton.style.visibility = "hidden";
                        let resendTimer: any = document.getElementById("id_resendTimer");
                        if (resendTimer) {
                            if (validationErrorMessage) {
                                validationErrorMessage.style.display = "none";
                            }

                            const response = await this.getLoginSMSValidationCode(payload);
                            if (response && response.data && response.data.timeout) {
                                resendTimer.innerHTML = formatTime(response.data.timeout);
                                if (s) {
                                    clearInterval(s);
                                }
                                s = setInterval(senderTimer, 1000);
                            }
                        }
                    });
                }

                const inputElements: any = document.querySelectorAll("input.code-input");
                inputElements.forEach((ele: any, index: any) => {
                    ele.addEventListener("keydown", (e: any) => {
                        // if the keycode is backspace & the current field is empty
                        // focus the input before the current. Then the event happens
                        // which will clear the "before" input box.
                        if (e.keyCode === 8 && e.target.value === "") inputElements[Math.max(0, index - 1)].focus();
                    });
                    ele.addEventListener("input", (e: any) => {
                        // take the first character of the input
                        // this actually breaks if you input an emoji like 👨‍👩‍👧‍👦....
                        // but I'm willing to overlook insane security code practices.
                        const [first, ...rest] = e.target.value;
                        e.target.value = first ?? ""; // first will be undefined when backspace was entered, so set the input to ""
                        const lastInputBox = index === inputElements.length - 1;
                        const didInsertContent = first !== undefined;
                        if (didInsertContent && !lastInputBox) {
                            // continue to input the rest of the string
                            inputElements[index + 1].focus();
                            // inputElements[index+1].value = rest.join('')
                            inputElements[index + 1].dispatchEvent(new Event("input"));
                        }

                        let validateCodeValue = [...inputElements].map((inp: any) => inp.value).join("");
                        if (validateCodeValue.length === 6) {
                            sureButton.disabled = false;
                        } else {
                            sureButton.disabled = true;
                        }
                    });
                });
            },
            content: `
              <p>
                ${mobile} GSM numaralı telefonunuza gönderdiğimiz doğrulama kodunu giriniz.
              </p>
              <div>
              
                <div id="id_validationErrorMessage" class="text-center alert alert-danger"></div>
                  
                <div class="mb-3 px-5 d-flex w-100">
                  <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
                  <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
                  <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
                  <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
                  <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
                  <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
                  <div class="clearfix"></div>
                </div>
                <div id="emailHelp" class="form-text"><span id="id_resendTimer">${formatTime(timeout)}</span> sonra tekrar gönder</div>
                <button style="bottom: 8px;" class="btn position-absolute btn-warning" id="id_resendCode">Tekrar Gönder</button>
              </div>`,
        });
    }

    // Re-Login Props
    async restoreLogin() {
        let savedData: any = Storage.get("member");
        if (savedData) {
            auth.member = new Member(savedData);
            auth.token = Storage.get("token");
            auth.authentication = true;
        }
    };

    // Logout Props
    async logout() {
        console.info("LOGOUT")

        auth.member = null;
        auth.token = null;
        auth.authentication = false;

        Storage.del("token");
        Storage.del("member");

        authSubject.next({ action: "logout" });
        loginModalSubject.next(false);
        window.location.href = "/";
    };

    // shared
    async validateMobile(payload: any, code: string) {
        auth.userValidation = false;
        const api = new ApiService();

        payload.mobile = payload.mobile.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "");
        payload.code = code.replaceAll(" ", "");

        try {
            const response: any = await api.start("post", env.accounting_api + "/member/api/mobile_validation/", payload, false);
            return response;
        } catch (e: any) {
            throw e;
        }
    };
}
